import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
  Grid,
  Typography,
  TextField, 
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel, 
  MenuItem, 
  FormGroup,
  Card,
  CardContent,
  FormHelperText
} from "@mui/material";


import {
  DeleteOutline,
  Edit,
  ViewList,
  FileCopy
} from "@mui/icons-material";
import {
  KeyboardTimePicker,
} from "components/pickers";



//react-tabulator
import 'react-tabulator/lib/styles.css'; // required styles
import 'react-tabulator/lib/css/tabulator.min.css'; // theme
import { ReactTabulator, reactFormatter } from 'react-tabulator';



import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr, enGB } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import ProductsLotModal from "../../../services/ProductsLotModal";
import { cellFocusEditor, dateEditor } from "../../../services/Common";
//import OrderModal from './OrderModal';


import { format } from 'date-fns';

let timeStamp = '';


//errorObject, addProductForm, formData, handleChange, handleCheck, handleReset, handleSubmit, handleUpdate, ManyTableData,ManyJsonSave,handleRDateChange,selectedDate,handleAdd,handleRefech,
const DispenserFormData = (props) => {
console.log("props==",props);
 // const ItemGroupId = props.match.params.id; //Get the url send id

  //console.log("ItemGroupId URL Param == ", ItemGroupId);

  //get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "dispense";
const FacilityId=localStorage.getItem('FacilityId');

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();
  const ReceiveDetailsRefHolder = useRef({ table: null });
  const ReceiveDetailsRef = ReceiveDetailsRefHolder.current;


  const [newBatchRowAdded, setNewBatchRowAdded] = useState(false);

  console.log("Set r batch");
  
  const [open, setOpen] = useState(false); 
  const [openLot, setOpenLot] = useState(false);
  const [openOrder, setOpenOrder] = useState(false);


/*   const [SoureOpen, setSoureOpen] = useState(false); 
  const [DatePickerOpen, setDatePickerOpen] = useState(false);  */

  const [manyTableData, setManyTableData] = useState([]);
  const [bStockUpdate, setbStockUpdate] = useState(false);
  

/*   let OrderToList = JSON.parse(localStorage.getItem("OrderTo"));
  const OrderTo = OrderToList.hasOwnProperty(props.formData.ItemGroupId)?OrderToList[props.formData.ItemGroupId]:[];
 */

  const UsersListByFacility =JSON.parse(localStorage.getItem("UsersListByFacility"));

  const [currRowId, setCurrRowId] = useState(0);
  const [currFormulation, setCurrFormulation] = useState("");
  const [currExpiryDate, setCurrExpiryDate] = useState("");
  const [bIsDisable, setbIsEnable] = useState(false);


  /* =====Start of Print Excel Many Code==== */
const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

const PrintMany = () => {
  
  let finalUrl = EXCEL_EXPORT_URL + "report/dispense_list_print.php";

  window.open(
    finalUrl +"?menukey=" +menukey
     + "&lan=" + localStorage.getItem("LangCode")
     +"&TransactionId=" + props.formData.TransactionId
     + "&FacilityId=" + FacilityId
     + "&TimeStamp=" + Date.now()
  );
};

const ExcelMany = () => {
  
  let finalUrl = EXCEL_EXPORT_URL + "report/dispense_list_excel.php";

  window.open(
    finalUrl +"?menukey=" +menukey
     + "&lan=" + localStorage.getItem("LangCode")
     +"&TransactionId=" + props.formData.TransactionId
     + "&FacilityId=" + FacilityId
     + "&TimeStamp=" + Date.now()
  );
};
/* =====End of Excel Export Code==== */
  
  
  const handleClose = (modalname) => {
    switch (modalname) {
      case "Products":
        setOpen(false);
        setOpenLot(false);
        break;
      case "ProductsOpen":
        setOpen(true);
        break;
      /* case "OrderModal":
        setOpenOrder(false);
        break; */
      case "OrderOpen":
        setOpenOrder(true);
         break; 
         case "LotOpen":
          setOpenLot(true);
          break;

    /*   case "SourceOpen":
        setSoureOpen(true);
        break;

      case "SourceClose":
          setSoureOpen(false);
          break;

      case "DatePickerOpen":
        setDatePickerOpen(true);
        break;

      case "DatePickerClose":
          setDatePickerOpen(false);
          break; */

      default:
        break;
    }
  }
  
  const addProduct = (NonOrderProductData) => {
 
   /*  let temNonordata=NonOrderProductData;
    let rows = [];
 
    let autoId=0;
    temNonordata.forEach((row,i) => {
      autoId++
      let newRow={} ;
      newRow.ItemNo =row.ItemNo;
      
      newRow.ItemCode =row.ItemCode;
    
      newRow.ItemName =row.ItemName;
      newRow.UnitPrice =row.UnitPrice;

      newRow.SourceId = null;
      newRow.SourceName = null;
  


      newRow.TransactionItemId = null;
      newRow.OrderRemainingQty = 0;

      manyTableData.forEach((rowssss,ij) => {
       
        if(rowssss.ItemNo==row.ItemNo) {
          newRow.OrderRemainingQty = rowssss.OrderRemainingQty;
          return;

        } 
      });


     
      newRow.CurrentStockQty = 0;
      newRow.Quantity =0;
      newRow.BatchNo = null;
      newRow.ExpiryDate = null;
      newRow.SKU=autoId;
      newRow.id=autoId;  
      newRow.LineTotal=0; 
      rows.push(newRow);
    
  });

  manyTableData.forEach((row,i) => {
    autoId++;
    let newRow={} ; 
    newRow.ItemNo =row.ItemNo;
    newRow.ItemCode =row.ItemCode;
    
    newRow.ItemName =row.ItemName;
    newRow.UnitPrice =row.UnitPrice; 
    newRow.TransactionItemId = row.TransactionItemId;
    newRow.OrderRemainingQty = row.OrderRemainingQty;
    newRow.CurrentStockQty = row.CurrentStockQty;
    newRow.Quantity =row.Quantity;
    newRow.BatchNo = row.BatchNo;
    newRow.ExpiryDate =row.ExpiryDate;
    newRow.SKU=autoId;
    newRow.id=autoId; 
    newRow.LineTotal=row.Quantity*row.UnitPrice; 

    newRow.SourceId = row.SourceId;
    newRow.SourceName = row.SourceName;

    rows.push(newRow);

   
  
}); 

    setManyTableData(rows);   
    props.handleAdd(rows); 
    handleClose('Products'); */


    let rowsNotInGrid = [];
      
    NonOrderProductData.map((row, i) => {
      row.TransactionItemId = null; 
      row.Remarks = null; 
      row.Quantity = 0; 
      row.LineTotal=0; 
      //row.IsPositive = -1; 
      //row.SKU = i + manyTableData.length+1+props.deleteAdjustmentInv.length;
    });


    if (props.ManyTableData.length > 0) {
      rowsNotInGrid = NonOrderProductData.filter((obj1) => {
      
          return !props.ManyTableData.some((obj2) => (obj1.BatchNo === obj2.BatchNo && obj1.ExpiryDate === obj2.ExpiryDate && obj1.ItemCode === obj2.ItemCode ));
        
      });
    } else {
      rowsNotInGrid = NonOrderProductData;
    }

    let arrObjOne=rowsNotInGrid.concat(props.ManyTableData)  ; 
    //const arrObjOne = [...new Map(person.map(item => [JSON.stringify(item), item])).values()];
       
      setManyTableData(arrObjOne);
      props.handleAdd(arrObjOne);
      
      handleClose("Products");

    
  }; 

/* 
  const addSource = (productSourceData) => {
    if (!productSourceData) {
      return;
    }

    // console.log("rows before pick product: ", manyTableData);
    // console.log("Product batch selected data: ", productBatchData);
    // console.log("Product batch selected currRowId: ", currRowId);

    let tempProductSourceData = productSourceData[0];
    let rows = [];

    let autoId = Date.now(); // 0;

    manyTableData.forEach((row, i) => {
      autoId++;
      let newRow = {};

      

      if (row.SKU === currRowId) {

        // if(row.TransactionItemId===null)
        // {
        //   //currFormulation
        // }
        // console.log("This is my row: ", row);
        // console.log("This is my row: ", temProductBatchData);
        newRow.SourceId = tempProductSourceData.SourceId;
        newRow.SourceName = tempProductSourceData.SourceName;
       
        
      } else {
        newRow.SourceId = row.SourceId;
        newRow.SourceName = row.SourceName;
  
      }


    newRow.ItemNo =row.ItemNo;
    newRow.ItemCode =row.ItemCode;
    
    newRow.ItemName =row.ItemName;
    newRow.UnitPrice =row.UnitPrice; 
    newRow.TransactionItemId = row.TransactionItemId;
    newRow.OrderRemainingQty = row.OrderRemainingQty;
    newRow.CurrentStockQty = row.CurrentStockQty;
    newRow.Quantity =row.Quantity;
    newRow.BatchNo = row.BatchNo;
    newRow.ExpiryDate =row.ExpiryDate;
    newRow.SKU=row.SKU;
    newRow.id=row.id; 
    newRow.LineTotal=row.Quantity*row.UnitPrice;

   // newRow.SourceId =row.SourceId;
    //newRow.SourceName =row.SourceName;
    


      rows.push(newRow);
    });

    // console.log("rows after link with product: ", rows);

    setManyTableData(rows);
    props.handleAdd(rows); 
    //productAdd(rows);
    handleClose("SourceClose");
  }; */



  
  const addDatePicker = (datePickerData) => {
    if (!datePickerData) {
      return;
    }
    
    let selectedExpiryDate = format(new Date(datePickerData), 'dd/MM/yyyy');
    console.log("selectedExpiryDate =========",selectedExpiryDate);
    let rows = [];

    let autoId = Date.now(); // 0;

    manyTableData.forEach((row, i) => {
      autoId++;
      let newRow = {};

      
      if (row.SKU === currRowId) {

        newRow.ExpiryDate = selectedExpiryDate;
       
      } else {
        newRow.ExpiryDate = row.ExpiryDate;
      
      }


    newRow.ItemNo =row.ItemNo;
    newRow.ItemCode =row.ItemCode;
    
    newRow.ItemName =row.ItemName;
    newRow.UnitPrice =row.UnitPrice; 
    newRow.TransactionItemId = row.TransactionItemId;
    newRow.OrderRemainingQty = row.OrderRemainingQty;
    newRow.CurrentStockQty = row.CurrentStockQty;
    newRow.Quantity =row.Quantity;
    newRow.BatchNo = row.BatchNo;
    //newRow.ExpiryDate =row.ExpiryDate;
    newRow.SourceId = row.SourceId;
    newRow.SourceName = row.SourceName;
    newRow.SKU=row.SKU;
    newRow.id=row.id; 
    newRow.LineTotal=row.Quantity*row.UnitPrice;

   // newRow.SourceId =row.SourceId;
    //newRow.SourceName =row.SourceName;
    


      rows.push(newRow);
    });

    // console.log("rows after link with product: ", rows);

    setManyTableData(rows);
    props.handleAdd(rows); 
    //productAdd(rows);
    handleClose("DatePickerClose");
  };


  /* function ShowSourcePopup(propss: any) {
    const rowData = propss.cell._cell.row.data;
    
    if ((props.bStockUpdate)) {
      return <></>;
    } else {
      
      return (
        <>
          <ViewList
            onClick={() => {
              setCurrRowId(rowData.SKU);
              setCurrFormulation(rowData.SKU);
              handleClose("SourceOpen");
            }}
          />
        </>
      );
    }
  } */


  function ShowDatePickerPopup(propss: any) {
    const rowData = propss.cell._cell.row.data;
    
    if ((props.bStockUpdate)) {
      return <></>;
    } else {
      
      return (
        <>
          <ViewList
            onClick={() => {
              setCurrRowId(rowData.SKU);
              setCurrFormulation(rowData.SKU);
             setCurrExpiryDate(rowData.ExpiryDate);
             // setCurrExpiryDate(rowData);
              //handleClose("DatePickerOpen");
            }}
          />
        </>
      );
    }
  }


  const ReceiveDetailsColumns = [
    { title: "id", field: "SKU", visible: false },
    { title: "id", field: "TransactionItemId", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]['Sl#']),
      width: 70,
      formatter: "rownum",
      hozAlign: "center",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      //visible: bStockUpdate == 0 ?true:false,
      title: t(DispensingLanguage[lan][menukey]['Actions']),
      field: "custom",
      headerSort: false,
      headerHozAlign: "center",
      hozAlign: "center",
      width: 100,
      formatter: reactFormatter(<ActionButton />),
    },
    {
      title: t(DispensingLanguage[lan][menukey]['Product Code']),
      field: "ItemCode",
      width: 130,
      headerFilter: true,
    },
    { title: t(DispensingLanguage[lan][menukey]['Product Name']), field: "ItemName", headerFilter: true },
    {
      title: t(DispensingLanguage[lan][menukey]['Current Stock']),
      field: "CurrentStockQty",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
      //visible:bIsPositive
    },
    {
      title: t(DispensingLanguage[lan][menukey]['Quantity']),
      field: "Quantity",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
      validator: ["integer", "min:0", function (cell, value, parameters) {
 
        if (value == "") return true;
       // if (!props.isPositive) return true;
        const balance = cell.getRow().getCell('CurrentStockQty').getValue();
        const validstatus = parseInt(value) <= parseInt(balance);  
        return validstatus; 
      }],
      cssClass: "tabluator-column-editable",
      editor: props.bStockUpdate == 0 ? cellFocusEditor : "",
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
        const pricecell = currow.getCell("LineTotal");
        const totprice = rowdata.UnitPrice * curcellval;
        pricecell.setValue(totprice);

       // props.setUpdatedDetailsGridDataHandler(currow._row.data);
      },
    }, //
    {
      title: t(DispensingLanguage[lan][menukey]['Lot No']),
      field: "BatchNo",
      width: 100,
      /* cssClass: "tabluator-column-editable text-field-editable",
      editor: props.bStockUpdate == 0 ? (props.isPositive?false: cellFocusEditor)   : "",
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
       // props.setUpdatedDetailsGridDataHandler(rowdata);
      }, */
    },
    {
      title: t(DispensingLanguage[lan][menukey]['Expiry Date']),
      field: "ExpiryDate",
      width: 100,
      //cssClass: "tabluator-column-editable text-field-editable",
      //editor: props.bStockUpdate == 0 ? (props.isPositive?false: dateEditor)  : "",
     // editor:  props.bStockUpdate == 0 ? (props.isPositive?false: cellFocusEditor) : '',   
      /* cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
       // props.setUpdatedDetailsGridDataHandler(rowdata);
      }, */
    },
   /*  {
      title: "",
      headerSort: false,
      field: "custom",
      hozAlign: "center",
      width: 8,
      formatter: reactFormatter(<ShowDatePickerPopup />),
    }, */
    { 
      title: "SourceId",
      field: "SourceId",
      visible: false,
    },
    { 
      title: t(DispensingLanguage[lan][menukey]['Source']),
       field: "SourceName",
       width: 120
    },
  /*   {
      title: "",
      headerSort: false,
      field: "custom",
      hozAlign: "center",
      width: 8,
      formatter: reactFormatter(<ShowSourcePopup />),
    }, */
    { title: t(DispensingLanguage[lan][menukey]['Unit Price (CFA)']), field: "UnitPrice" , width: 100, hozAlign: "right", headerHozAlign:"right", 
      validator:["min:0"],
     /*  cssClass: "tabluator-column-editable",
      editor: props.bStockUpdate == 0 ? cellFocusEditor: '',      
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
        const pricecell = currow.getCell("LineTotal");
        const totprice = rowdata.Quantity * curcellval;
        pricecell.setValue(totprice);
        
       // props.setUpdatedDetailsGridDataHandler(currow._row.data);
      }  */
    },
    { title: t(DispensingLanguage[lan][menukey]['Line Total (CFA)']), field: "LineTotal" , width: "10%",
      formatter: "money", hozAlign: "right", headerHozAlign:"right",
      bottomCalc: "sum",
      bottomCalcFormatter: "money"
       
    },
    
  ];
   
  // const ReceiveDetailsDataItems = manyTableData?.map((item, index) => {
   
  //  // item["sl"] = index + 1;
    
  //   item["LineTotal"] = item.Quantity*item.UnitPrice;
  //   return item;
  // }); 
  
 
  // setManyTableData((preManyTableData) => {

  //   const updatedManyTableData = preManyTableData?.map((item, index) => {

  //     // item["sl"] = index + 1;

  //     item["LineTotal"] = item.Quantity * item.UnitPrice;
  //     return item;
  //   });

  //   return updatedManyTableData;

  // });



   const onPostBtnClick = () => { 
    setbStockUpdate(true); 
    props.handlePost();

  }

  const onSaveUpdateBtnClick = () => { 
    if (props.isSubmitting) return;
    props.setUpdatedDetailsGridDataHandler(ReceiveDetailsRef.table.getData()); 
  //  props.handleUpdate();
  }

  const deleteDispenseInv = (data) => { 
    let newarray = manyTableData.filter(element => element !== data); 
    setManyTableData(newarray); 
    props.deleteDispenseInv(data); 
  };


  const CopyBatch = () => {
    
    props.handleAdd(manyTableData); 
    
  };

  

  

  function ActionButton (props) { 

    //console.log("console props......", props123);

   // return;

    const rowData = props.cell._cell.row.data;  


    const goToDetails = () => {

      let rowobj = props.cell._cell.row.data; //{};
      console.log("I copied this line", rowobj);
      //console.log("I copied this line", props.cell._cell.row);

      timeStamp = Math.round(new Date().getTime() / 100);

      



      setManyTableData((prevRows) => {

        const tmpPrevRows = [...prevRows];

        let setRposition = tmpPrevRows.findIndex((o) => o.SKU ==rowobj.SKU);
        console.log("Rposition",setRposition);

        const obj = { ...rowobj };

        obj.id = timeStamp;
        obj.TransactionItemId = "";
        obj.ExpiryDate = "";
        obj.BatchNo = "";
        obj.Quantity = 0;
        obj.SKU = Date.now();

        console.log("new object added in grid:", obj);
        tmpPrevRows.splice(setRposition+1, 0, obj)

        return tmpPrevRows;
      });

      // props.handleAdd(manyTableData); 
      CopyBatch();
      setNewBatchRowAdded((prevNewBatchRowAdded) => !prevNewBatchRowAdded);
      

    };
   

    const cellValue = props.cell._cell.value || 'Edit | Show';
    if(bStockUpdate == 0)
    return (
      <>

        {/* <FileCopy
          onClick={() => {
            if (!bStockUpdate) goToDetails(rowData);
          }}
        /> */}

        <DeleteOutline
          onClick={() => {
            if (!bStockUpdate) deleteDispenseInv(rowData);
          }}
        />
      </>
    );
    else  return (
      <>
         
      </>
    );
  }

  
  
  useEffect(() => {
    if(props.bFirst){
      setManyTableData(props.ManyTableData);
    }

    setbStockUpdate(props.bStockUpdate);
}, [props.ManyTableData,props.bStockUpdate]); //


useEffect(() => {
  if (ReceiveDetailsRef.table != null && timeStamp != '') {

    console.log("Many table",ReceiveDetailsRef.table);
    console.log("Many table 12222222222");

    ReceiveDetailsRef.table.scrollToRow(timeStamp, "center", true);
    ReceiveDetailsRef.table.selectRow(timeStamp);


  }
}, [newBatchRowAdded])

const handleReset = () => {
  setManyTableData([]);  
  props.handleReset();
};

  return (
    <div className={classes.productPageTitle}>
    <div className="sw_makeStyles_tableContainer">
      <div className="d-flex justify-product mb-3">
        <Grid container>
        <Grid item xs={12} sm={12}>
        <div className="sw_page_heading">
            <div className="sw_heading_title">{DispensingLanguage[lan][menukey]['Dispense - Add/Edit']}</div>
            <div className="float-end sw_btn_control">

            {
            props.addProductForm ?
              <Grid item xs={12} className="mt-4 text-center">
               <div className="float-end sw_btn_control">
                <Button
                  className="me-2"
                  variant="contained"
                  color="gray"
                  type="reset"
                  onClick={() => handleReset()}
                  // onClick={() => props.handleReset()}
                >
                  {DispensingLanguage[lan][menukey]['Reset']}
                </Button>
                <Button
                  className="me-2"
                  variant="contained"
                  color="primary"
                  disabled={!!props.isSubmitting}
                  onClick={onSaveUpdateBtnClick}//() => props.handleSubmit()
                >
                  {DispensingLanguage[lan][menukey]['Save']}
                </Button>
                <Button
                  className="me-2"
                  variant="contained"
                  color="gray"
                  type="reset"
                  onClick={() => props.history.push("/dispense")}
                >
                  {DispensingLanguage[lan][menukey]['Back to List']}
                </Button>
               </div>
              </Grid>
              :
              <Grid item xs={12} className="mt-2 text-center">
                <Button
                  disabled={!!props.bStockUpdate || !!props.isSubmitting}
                  className="me-2"
                  variant="contained"
                  color="primary"
                  onClick={onSaveUpdateBtnClick}
                   
                >
                 {DispensingLanguage[lan][menukey]['update']}
                </Button>
                <Button 
                  disabled={!!props.bStockUpdate || !!props.isSubmitting}
                  className="me-2"
                  variant="contained"
                  color="primary"
                  onClick={onPostBtnClick}
                >
                  {DispensingLanguage[lan][menukey]['post']}
                </Button>
                <Button
                  className="me-2"
                  variant="contained"
                  color="gray"
                  type="reset"
                  onClick={() => props.history.push("/dispense")}
                >
                 {DispensingLanguage[lan][menukey]['Back to List']}
                </Button>

                <Button
                variant="contained"
                color="primary"
                className="me-2 sw_icons"
                onClick={() => PrintMany()}
                >
                <i className="fas fa-print"></i>
                </Button>

                <Button
                variant="contained"
                color="primary"
                className="me-2 sw_icons"
                onClick={() => ExcelMany()}
                >
                <i className="far fa-file-excel"></i>
                </Button>

              </Grid>
          }

            </div>
         </div>   
        </Grid>
       </Grid>
      </div>

      <Grid container spacing={3} className="mb-3">
        <Grid item xs={3} sm={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                            <DatePicker
                  disabled={!!props.bStockUpdate}
                  //disableToolbar
                  label={DispensingLanguage[lan][menukey]['Dispense Date']}
                  value={props.formData.TransactionDate||props.selectedDate}
                  inputFormat="dd/MM/yyyy"
                  onChange={(e) => props.handleRDateChange(e, "TransactionDate")}
                                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    required
                    error={!!props.errorObject.TransactionDate}
                    helperText={props.errorObject.TransactionDate}
                    className={classes.fullWidth}
                    id="TransactionDate"
                    name="TransactionDate"
                    fullWidth
                  />
                )}
              />
            </LocalizationProvider> 
        </Grid>
        
        <Grid item xs={3} sm={3}>
          <TextField variant="standard"
              disabled={true/*bStockUpdate*/}
              error={!!props.errorObject.TransactionNo}
              helperText={props.errorObject.TransactionNo}
              required
            id="TransactionNo"
            name="TransactionNo"
            label={DispensingLanguage[lan][menukey]['Dispense Invoice No']} 
            // value={formData.FirstName || "Mahmudul"}
            value={props.formData.TransactionNo||props.generatedInvoiceNo||""}
            fullWidth
            autoComplete="family-name"
            onChange={(e) => props.handleChange(e)}
          />
        </Grid>
        
        <Grid item xs={3} sm={3}>
          <FormControl variant="standard" className={classes.fullWidth}>
            <InputLabel id="demo-simple-select-helper-label">
            
              {DispensingLanguage[lan][menukey]["Prepared By"]} *
            </InputLabel>
            <Select
              error={!!props.errorObject.PreparedBy}
          
              labelId="demo-simple-select-helper-label"
              id="PreparedBy"
              name="PreparedBy"
              value={props.formData.PreparedBy||""}
              fullWidth
              onChange={(e) => props.handleChange(e)}
              disabled={!!(props.IsCompleted || props.bStockUpdate)}
            label={`${DispensingLanguage[lan][menukey]["Prepared By"]} *`}>
            {UsersListByFacility.map((item, index) => {
                return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
              })}
            </Select>
            <FormHelperText error={!!props.errorObject.PreparedBy}>
              {props.errorObject.PreparedBy}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={3} sm={3}>
          <FormControl variant="standard" className={classes.fullWidth}>
            <InputLabel id="demo-simple-select-helper-label">
            
              {DispensingLanguage[lan][menukey]["Approved By"]} *
            </InputLabel>
            <Select
              error={!!props.errorObject.ApprovedBy}
          
              labelId="demo-simple-select-helper-label"
              id="ApprovedBy"
              name="ApprovedBy"
              value={props.formData.ApprovedBy||""}
              fullWidth
              onChange={(e) => props.handleChange(e)}
              disabled={!!(props.IsCompleted || props.bStockUpdate)}
            label={`${DispensingLanguage[lan][menukey]["Approved By"]} *`}>
            {UsersListByFacility.map((item, index) => {
                return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
              })}
            </Select>
            <FormHelperText error={!!props.errorObject.ApprovedBy}>
              {props.errorObject.ApprovedBy}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={3} sm={3}>
          <TextField variant="standard" 
            id="FacilityId"
            name="FacilityId"
            label="FacilityId"
            value={props.formData.FacilityId || ""}
            fullWidth
            hidden
            autoComplete="family-name" 
          />
          <TextField variant="standard" 
            id="TransactionId"
            name="TransactionId"
            label="TransactionId"  
            value={props.formData.TransactionId || ""}
            fullWidth
            hidden
            autoComplete="family-name" 
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <Card className="sw_card">
              <CardContent>
                <Grid container className="mb-2">
                  <Grid item xs={12} sm={12}>
                    <div className="float-end sw_btn_control">
                      <Button
                        disabled={!!props.bStockUpdate}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => handleClose("LotOpen")}
                      >
                        {DispensingLanguage[lan][menukey]['SELECT PRODUCT']}  
                      </Button> 
                    </div>

                    <ProductsLotModal handleClose={handleClose} open={openLot} FacilityId={FacilityId} addProduct={addProduct} {...props} />
                  </Grid>
                </Grid> 
                  <ReactTabulator
                    onRef={(r) => { ReceiveDetailsRef.table = r.current; }}
                    columns={ReceiveDetailsColumns}
                    data={manyTableData}
                    height="350px"
                    layout={"fitColumns"}
                  />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
    </div>
  </div>
  );
};

export default DispenserFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
